/**
 * Unter dieser Breite rutscht die Navigation in eine zweite Zeile und Seiten stapeln ihre Spalten.
 * **Die Zahl steht zusätzlich in `design/shell.css`** (CSS kennt keine TypeScript-Konstante); `design.test.ts` prüft,
 * dass sie dort dieselbe ist.
 */
export const MOBILE_BREAKPOINT = '640px';

/** Für Griffel-Stile: `[MEDIA_MOBILE]: { … }`. */
export const MEDIA_MOBILE = `@media (max-width: ${MOBILE_BREAKPOINT})`;
